import React, { useState, useEffect, useCallback } from "react";

import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";

const EquipDetailHeader = ({
  title,
  description,
  buttonTitle,
  onClickHandler,
  hideButtonFlag,
}) => {
  return (
    <>
      <div className="">
        <Typography gutterBottom variant="h4" component="div">
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {description}
        </Typography>
      </div>
      {!hideButtonFlag && (
        <div>
          <Button
            variant="contained"
            className="containedBtnCls"
            sx={{ textTransform: "none" }}
            size="large"
            onClick={onClickHandler}
          >
            {buttonTitle}
          </Button>
        </div>
      )}
    </>
  );
};
export default EquipDetailHeader;
